























import { Vue, Component, Prop } from 'vue-property-decorator';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';

@Component({
  components: { ChevronRightSolid, DateRangePicker },
})
export default class DateRangeInput extends Vue {
  @Prop({ type: String, default: "Select a range" }) label: string;
  @Prop(Object) value: () => ({});
  @Prop(String) customOpen: '';
  @Prop(String) minDate: '';

  $refs: {
    dateRangeBtn: HTMLButtonElement;
    chevronDate: Vue;
  }

  hasAValue: boolean = false;
  openType: string = 'center';

  /* Destructuring v-model in a getter/setter to have a custom input container */
  get inputValue () {
    return this.value;
  }

  /* ⬆️ */
  set inputValue (value) {
    this.$emit('input', value);
  }

  mounted () {
    // Is triggered the first time to give a default direction to the picker
    this.adaptRangeDisplay();

    // Will force the component to update its styles to 'non-selected'-mode
    this.$root.$on('reset-date-range', () => {
      this.hasAValue = false;
    });

    // Will force the component to update its styles to 'selected'-mode
    this.$root.$on('has-a-prefilled-value', () => {
      this.hasAValue = true;
    });

    // When user resizes his window, we can trigger direction method to adapt
    if (process.client) {
      window.addEventListener('resize', this.adaptRangeDisplay, false);
    }
  }

  /* Remove the resize event listener when changing page */
  beforeDestroy () {
    if (process.client) {
      window.removeEventListener('resize', this.adaptRangeDisplay, false);
    }
  }

  /*
    This method will allow the range plugin to adapt the direction the
    dropdown must go, based on device's innerWidth
  */
  adaptRangeDisplay () {
    if (process.client) {
      if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        this.openType = 'right';
        return this.openType;
      }
      this.openType = 'center';
      return this.openType;
    }
    return this.openType;
  }

  toggling (val: boolean) {
    if (val) {
      this.$refs.dateRangeBtn.classList.remove('border-gray-200');
      this.$refs.dateRangeBtn.classList.add('border-gray-default');
      this.$refs.chevronDate.$el.classList.add('-rotate-180', '-rotate-90');
    } else {
      if (!this.hasAValue) {
        this.$refs.dateRangeBtn.classList.remove('border-gray-default');
      }
      this.$refs.dateRangeBtn.classList.add('border-gray-200');
      this.$refs.chevronDate.$el.classList.remove('-rotate-180', '-rotate-90');
    }
  }
}
